'use client'

import type { FC, ReactNode } from 'react'

import { Button } from '@/components/shared/ui/base/buttons/button'

interface LinkCellProps {
  children?: ReactNode
  href?: string
  onClick?: () => void
  color?: 'link-color' | 'link-gray' | 'link-destructive'
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  iconLeading?: FC<{ className?: string }> | ReactNode
  className?: string
  'aria-label'?: string
}

export function LinkCell({
  children,
  href,
  onClick,
  color = 'link-color',
  size = 'sm',
  iconLeading,
  className,
  'aria-label': ariaLabel,
}: LinkCellProps) {
  return (
    <Button
      color={color}
      size={size}
      href={href}
      onClick={onClick}
      iconLeading={iconLeading}
      className={className}
      aria-label={ariaLabel}
    >
      {children}
    </Button>
  )
}
